import { Component, Inject  } from '@angular/core';
import { MatDialogRef as MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'dialog-delete',
  templateUrl: './dialog-delete.component.html',
  styleUrls : ['./dialog-delete.component.css']
})
export class DialogDelete {

  constructor(
    public dialogRef: MatDialogRef<DialogDelete>, @Inject(MAT_DIALOG_DATA) public data) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}